import { render, staticRenderFns } from "./compute-time.vue?vue&type=template&id=73637248&scoped=true"
import script from "./compute-time.vue?vue&type=script&lang=js"
export * from "./compute-time.vue?vue&type=script&lang=js"
import style0 from "./compute-time.vue?vue&type=style&index=0&id=73637248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73637248",
  null
  
)

export default component.exports